import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
@Injectable()
export class BasicService {
    url = environment.URL;
    constructor() { }
}
